

































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {SelectOption} from "@/util/selectOption";
import axios from 'axios';
import {currency} from "@/util/formatter";

@Component
export default class TaxLiability extends Vue {

    @Prop()
    availableYears!: number[];

    private isLoading: boolean = false;

    private totalTaxDue: string = '';
    private taxDue: string = '';
    private nicDue: string = '';
    private isRebate: boolean = false;

    private yearOptions: SelectOption[] = this.availableYears.map(year => {
        return {
            name: `${year} - ${year+1}`,
            id: year
        }
    });

    private yearOption: SelectOption = this.yearOptions[0];

    private mounted() {
        this.fetchData();
    }

    @Watch('yearOption')
    private onYearOptionChanged(newOption: SelectOption) {
        this.fetchData();
    }

    private fetchData() {
        this.isLoading = true;

        axios.get(`/reports/chart/tax?year=${this.yearOption.id}`)
            .then(result => {
                const data = result.data;
                this.totalTaxDue = currency(data.total_tax_due);
                this.taxDue = currency(Math.abs(data.tax_due));
                this.nicDue = currency(data.nic_due);

                this.isRebate = data.tax_due < 0;
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                this.isLoading = false;
            })
    }
}
